module.exports = global["jQuery"] = require("-!/start/assets/node_modules/expose-loader/index.js?$!/start/assets/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 8
// module chunks = 12 13 14 16 17 19 20 21 22 23 24 25 26 27 28 29 31 32 33 34 35 36 38 39 40